var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7 44.818c-1.395.906-2.86 1.464-4.394 1.674-3 .488-6.068-.21-8.51-1.884a5.271 5.271 0 0 1-.976-.767c-1.953 1.744-4.464 2.79-7.254 2.79-3.278 0-6.138-1.465-8.16-3.697-1.605 2.232-4.185 3.697-7.115 3.697-4.813 0-8.718-3.906-8.718-8.72 0-2.93 1.395-5.44 3.557-7.045 1.325-.977 2.86-1.535 4.603-1.674-.21-.698-.279-1.465-.279-2.233 0-4.115 3-7.534 6.975-8.161.419-.07.837-.14 1.325-.14 1.395 0 2.65.349 3.767.907.07-.279.209-.488.348-.767 1.744-3.697 5.51-6.278 9.835-6.278 1.116 0 2.232.209 3.278.488 3.557 1.116 6.347 3.976 7.324 7.603.209.837.349 1.675.349 2.581a11.635 11.635 0 0 1 7.742 5.232c.906 1.396 1.464 2.86 1.674 4.395.697 4.604-1.256 9.348-5.371 11.998Z",
    fill: "#F2F4F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.611 50.198c0 .16-.08.24-.08.401-.16.641-.32 1.202-.56 1.763-.08.08-.079.24-.159.32l-.72 1.203c-.079.16-.239.32-.319.4-.719.802-1.518 1.523-2.476 1.924-.16.08-.32.16-.56.24-.319.16-.639.24-.958.32-1.278.401-2.557.401-3.915.16a8.155 8.155 0 0 1-6.47-7.051c-.08-.882-.08-1.843.079-2.725a7.896 7.896 0 0 1 3.196-4.968c1.837-1.363 4.154-1.924 6.55-1.443a8.14 8.14 0 0 1 4.155 2.244c1.039 1.042 1.837 2.404 2.157 3.847.16 1.122.24 2.243.08 3.365Z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.463 55.888c-.48 0-.959-.08-1.438-.16-3.755-.802-6.152-4.488-5.433-8.255a7.084 7.084 0 0 1 2.956-4.407c1.518-1.042 3.435-1.363 5.193-.962 1.358.24 2.556.962 3.515 1.924 1.678 1.683 2.397 4.007 1.918 6.33-.08.481-.24 1.042-.48 1.443 0 .08-.08.16-.16.32-.16.32-.4.722-.639 1.042-.08.16-.16.24-.32.32a5.636 5.636 0 0 1-2.156 1.684l-.48.24c-.32.16-.559.24-.799.24-.399.16-1.038.24-1.677.24Zm0-13.303c-1.199 0-2.397.32-3.436 1.042-1.438.962-2.396 2.324-2.716 4.007-.719 3.446 1.518 6.812 4.953 7.533 1.039.24 2.078.16 3.036-.08l.72-.24c.16-.08.239-.161.399-.161.719-.4 1.358-.882 1.917-1.523.08-.08.16-.24.24-.32.24-.32.4-.561.559-.882.08-.08.08-.16.16-.24.24-.401.32-.882.48-1.362.479-2.084-.24-4.248-1.758-5.77-.88-.882-1.998-1.443-3.196-1.763-.48-.24-.959-.24-1.358-.24Z",
    fill: "#F9B400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.722 52.755c-.24.4-.4.8-.72 1.121-.08.16-.239.321-.319.401-.719.801-1.598 1.443-2.476 2.004-.16.08-.32.16-.56.24-.32.16-.639.24-.958.32l-5.113-5.128 1.677-.882.16-.4.08-.802s-.08-2.885-.16-3.045l.48-1.923.559 1.282.719-1.282 7.03 7.052c0 .24-.32.961-.4 1.041Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.812 53.075h-.798v-1.282c-.48-.08-.96 0-1.519 0 .08-.641.08-.641.16-.882 0-.08 0-.08.08-.08h.48c.24 0 .32-.08.32-.24v-3.206c0-.32-.16-.4-.4-.4h-.56v-.802h1.359c.08 0 .08 0 .08-.08v-1.282h.798v1.282h.56v-1.282h.719v1.282c0 .08 0 .08.08.08.878.08 1.677.401 1.757 1.282 0 .321 0 .642-.24.882-.16.16-.32.24-.399.32.24.08.799.241 1.039.882.08.24.08.48.08.721 0 .24-.16.561-.32.721-.16.24-.48.401-.72.562-.399.16-.718.16-1.118.24-.08 0-.08 0-.08.08v1.202h-.718v-1.282h-.56c-.08.4-.08.881-.08 1.282Zm2.078-2.965c0-.24-.08-.48-.32-.641-.4-.24-1.278-.24-1.678-.24v1.682c.8 0 1.199 0 1.678-.24.16-.16.32-.32.32-.561Zm-2.078-3.125v1.522c.32 0 .88 0 1.119-.08.799-.24.639-1.042.16-1.282-.4-.24-.88-.16-1.279-.16Z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6 50.27c-.4 0-.799.08-1.198.08-3.675 0-7.03-1.682-9.347-4.247-1.358 1.923-3.436 3.366-5.753 3.927-.08-.882-.08-1.843.08-2.725a7.896 7.896 0 0 1 3.196-4.968c1.838.801 3.435 2.404 5.193 3.446 2.317 1.362 5.113 1.763 7.67 1.202.32.961.32 2.163.16 3.285Z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.69 46.103c-1.598 1.042-3.276 1.683-5.034 1.924-3.435.56-6.95-.24-9.746-2.164-.4-.24-.8-.561-1.119-.882-2.237 2.004-5.113 3.206-8.308 3.206-3.755 0-7.03-1.683-9.348-4.247-1.837 2.564-4.793 4.247-8.149 4.247-5.512 0-9.986-4.488-9.986-10.017 0-3.366 1.598-6.25 4.074-8.094 1.518-1.122 3.276-1.763 5.273-1.923-.24-.802-.32-1.683-.32-2.565a9.476 9.476 0 0 1 7.99-9.376c.48-.08.959-.16 1.518-.16 1.598 0 3.036.4 4.314 1.042.08-.32.24-.561.4-.882C38.244 11.965 42.558 9 47.512 9c1.278 0 2.556.24 3.755.561a12.61 12.61 0 0 1 8.388 8.735c.24.962.4 1.923.4 2.965a13.325 13.325 0 0 1 8.868 6.01c1.038 1.603 1.677 3.286 1.917 5.049.799 5.289-1.438 10.738-6.152 13.783Z",
    fill: "#F2F4F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.69 46.103c-1.598 1.042-3.276 1.683-5.034 1.924-3.435.56-6.95-.24-9.746-2.164-.4-.24-.8-.561-1.119-.882-2.237 2.004-5.113 3.206-8.308 3.206-3.755 0-7.03-1.683-9.348-4.247-1.837 2.564-4.793 4.247-8.149 4.247-5.512 0-9.986-4.488-9.986-10.017 0-3.366 1.598-6.25 4.074-8.094 1.518-1.122 3.276-1.763 5.273-1.923-.24-.802-.32-1.683-.32-2.565a9.476 9.476 0 0 1 7.99-9.376c.48-.08.959-.16 1.518-.16 1.598 0 3.036.4 4.314 1.042.08-.32.24-.561.4-.882C38.244 11.965 42.558 9 47.512 9c1.278 0 2.556.24 3.755.561a12.61 12.61 0 0 1 8.388 8.735c.24.962.4 1.923.4 2.965a13.325 13.325 0 0 1 8.868 6.01c1.038 1.603 1.677 3.286 1.917 5.049.799 5.289-1.438 10.738-6.152 13.783Z",
    fill: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.168 30.076c-.08-.24-.32-.561-.56-.641-.479-.24-1.118 0-1.517-.4a.729.729 0 0 1-.24-.562c-.24-1.442.64-3.205-.24-4.407-.16-.24-.479-.481-.639-.722-.559-.801-.479-1.683-1.278-2.244-.719-.4-1.997-.56-2.796-.32-2.077.641-3.755 3.205-3.276 5.289.08.32.24.721.48.882.878.56 2.237-.722 2.956.08.32.32.24.881.16 1.282-.24 1.122-.4 2.244-.48 3.285-.08.481-.08 1.042.16 1.443.24.56.799.801 1.358 1.042 1.438.48 3.116.56 4.474-.24 1.198-.562 1.997-2.325 1.438-3.767Z",
    fill: "url(#g)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.225 32.48c-.16 0-.32 0-.48.08-2.636.641-3.994 2.885-2.875 5.37.32.64.719 1.281 1.358 1.522.639.24 1.598-.24 1.518-.962 0-.16-.08-.4-.16-.56-.16-.562.08-1.123.48-1.523.399-.401.878-.641 1.437-.802.32-.08.64-.24.88-.48.319-.321.319-.882.159-1.283-.24-.961-1.278-1.442-2.317-1.362Z",
    fill: "url(#h)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.95 14.61c-.24-.16-.48-.16-.799-.16-3.675-.321-8.069 0-9.267 4.247-.32 1.041-.32 2.163-.16 3.205.08.641.24 1.282.56 1.763.319.56.878.962 1.517.962.64 0 1.199-.321 1.598-.802.4-.48.719-1.042.959-1.602.879-1.683 2.237-3.366 4.074-3.687.48-.08 1.039-.08 1.518-.32.959-.561.959-2.004.4-3.046 0-.16-.16-.4-.4-.56Z",
    fill: "url(#i)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.515 31.518c-1.039.401-1.438 1.763-1.918 2.805-1.038 2.244-3.035 4.087-5.432 4.808-1.039.32-5.353.802-3.036 2.565 1.198.881 2.397 1.763 3.835 2.003 1.598.24 3.195-.48 4.474-1.362 2.157-1.523 3.755-3.767 4.553-6.25.32-.963.48-2.085.08-3.046-.4-.962-1.438-1.763-2.396-1.443 0-.08-.08-.08-.16-.08Z",
    fill: "url(#j)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.052 27.511c-.16-.4-.56-.72-.959-.961-.878-.481-1.917-.722-2.876-.481-3.035.801-4.314 4.968-2.876 7.533.16.32.4.56.72.64.239 0 .399-.08.559-.16 1.118-.88.479-3.045 1.677-3.846.88-.641 2.077 0 3.196-.08.16 0 .32 0 .4-.16.16-.08.16-.32.16-.481.159-.641.319-1.363 0-2.004Z",
    fill: "url(#k)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.502 43.378c-1.04-.72-5.753-3.526-4.075.321.32.721 1.198 1.122 1.917 1.442.48.24 1.039.401 1.518.642.4.16.88.32 1.279.16.479-.24.639-.882.4-1.443-.16-.48-.64-.801-1.04-1.122Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.937 16.212c.48-.08.959-.16 1.518-.16 1.598 0 3.036.4 4.314 1.042.08-.32.24-.561.4-.882-.56 2.805-.08 5.85.399 8.735-3.196-1.843-3.515-6.811-6.631-8.735Z",
    fill: "url(#l)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69 46.103c-1.598 1.042-3.276 1.683-5.034 1.923-1.278-1.202-1.997-3.045-3.036-4.487-1.198-1.683-3.435-2.965-5.192-1.924-1.119.642-1.598 2.084-1.598 3.446 0 .321 0 .561.08.802-.4-.24-.8-.561-1.119-.882-2.237 2.004-5.113 3.206-8.308 3.206-3.755 0-7.03-1.683-9.348-4.247-1.837 2.564-4.793 4.247-8.149 4.247-5.512 0-9.986-4.488-9.986-10.017 0-3.366 1.598-6.251 4.074-8.094.4 1.122-.16 2.404-.399 3.606-.879 4.167 1.917 8.735 5.992 9.857.799.24 1.757.32 2.476-.08.72-.401 1.199-1.443.72-2.164-.16-.24-.4-.48-.48-.721-.16-.641.799-.962 1.438-.882 2.716.32 4.634 2.565 7.03 3.927 3.516 2.003 8.15 1.843 11.585-.32 3.435-2.164 5.592-6.171 5.592-10.258 0-2.244-.56-4.488.08-6.571.719-2.565 3.036-4.408 3.675-7.052.4-1.763-.08-3.687-1.278-4.969-.959-.961-2.157-1.683-2.637-2.805-.24-.64-.16-1.442.24-2.003a12.611 12.611 0 0 1 8.389 8.735c-.96.881-1.758 1.843-2.237 3.045-.32.802-.4 1.683-.72 2.564-.319.722-.718 1.363-1.118 2.004-2.556 4.407-1.598 10.658 2.237 14.024 1.278 1.122 2.956 2.003 4.714 1.923 2.157-.08 3.994-1.603 5.113-3.526 1.118-1.843 1.517-4.007 1.997-6.09 0-.16.08-.32.16-.401.32-.4.879-.08 1.118.32.879 5.37-1.358 10.819-6.072 13.864Z",
    fill: "url(#m)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M64.69 46.103c-1.598 1.042-3.276 1.683-5.034 1.924-3.435.56-6.95-.24-9.746-2.164a6.04 6.04 0 0 1-1.119-.882c-2.237 2.004-5.113 3.206-8.308 3.206-3.755 0-7.03-1.683-9.348-4.247-1.837 2.564-4.793 4.247-8.149 4.247-5.512 0-9.986-4.488-9.986-10.017 0-3.366 1.598-6.25 4.074-8.094 1.518-1.122 3.276-1.763 5.273-1.923-.24-.802-.32-1.683-.32-2.565a9.476 9.476 0 0 1 7.99-9.376c.48-.08.959-.16 1.518-.16 1.598 0 3.036.4 4.314 1.042.08-.32.24-.561.4-.882C38.244 11.965 42.558 9 47.512 9c1.278 0 2.556.24 3.755.561a12.61 12.61 0 0 1 8.388 8.735c.24.962.4 1.923.4 2.965a13.325 13.325 0 0 1 8.868 6.01c1.038 1.603 1.677 3.286 1.917 5.049.799 5.289-1.438 10.738-6.152 13.783Z",
    stroke: "#E4E6F1",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.065 42.104c0 .561-.08 1.042-.16 1.603-.08.641-.319 1.202-.559 1.763-.08.08-.08.24-.16.32l-.718 1.203c-.08.16-.24.32-.32.4-.719.802-1.598 1.443-2.477 1.924-.16.08-.32.16-.559.24-.32.16-.639.24-.959.32-1.198.321-2.556.402-3.914.161-4.314-.881-7.11-4.968-6.471-9.296 0-.16.08-.32.08-.48.08-.401.16-.722.32-1.123.718-.24 1.277-.56 1.916-.881.88-.48 1.678-.802 2.477-.962 1.118-.32 2.157-.4 3.196-.32 3.115.24 5.672 1.923 8.308 3.285 0 .721.08 1.282 0 1.843Z",
    fill: "url(#n)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.388 39.62c-.32-.16-.56-.32-.879-.4a5.86 5.86 0 0 1 .719 2.805c0 .4 0 .88-.16 1.281-.08.481-.24.882-.479 1.363 0 .08-.08.16-.08.24-.16.32-.32.641-.56.882-.08.16-.159.24-.239.32-.56.641-1.198 1.122-1.917 1.523-.16.08-.24.16-.4.16l-.719.24c-.959.321-1.997.321-3.036.08-3.435-.72-5.592-4.086-4.953-7.532a7.06 7.06 0 0 1 1.358-2.805c-.32.16-.639.24-.958.48-.08 0-.08.081-.16.081-.4.641-.72 1.362-.879 2.164-.799 3.766 1.678 7.453 5.433 8.254.479.08.958.16 1.438.16.639 0 1.278-.08 1.917-.24.24-.08.48-.16.799-.32l.48-.241a7.17 7.17 0 0 0 2.156-1.683c.08-.08.16-.24.32-.4.24-.321.48-.642.639-1.043.08-.08.08-.24.16-.32.24-.481.4-.962.48-1.523.079-1.041 0-2.324-.48-3.526Z",
    fill: "#F9B400"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.095 45.863c-.24.4-.4.801-.72 1.122-.08.16-.239.32-.319.4-.719.802-1.598 1.443-2.476 2.004-.16.08-.32.16-.56.24-.32.16-.639.24-.958.32l-5.113-5.128 1.677-.881.16-.401.08-.802s-.08-2.884-.16-3.045l.48-1.923.559 1.282.719-1.282 7.03 7.052c.08.24-.32.962-.4 1.042Z",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.265 46.183h-.798v-1.282c-.48-.08-.96 0-1.518 0 .08-.64.08-.64.16-.881 0-.08 0-.08.08-.08h.479c.24 0 .32-.08.32-.24v-3.206c0-.32-.16-.401-.4-.401h-.56v-.801h1.359c.08 0 .08 0 .08-.08v-1.283h.798v1.282h.56V37.93h.719v1.282c0 .08 0 .08.08.08.878.08 1.677.401 1.757 1.283 0 .32 0 .64-.24.881-.16.16-.319.24-.399.32.24.081.799.241 1.039.882.08.24.08.481.08.722 0 .24-.16.56-.32.72-.16.241-.48.402-.719.562-.4.16-.72.16-1.119.24-.08 0-.08 0-.08.08v1.202h-.718v-1.282h-.56c-.08.4-.08.882-.08 1.282Zm1.998-2.965c0-.24-.08-.48-.32-.64-.4-.321-1.198-.241-1.678-.241v1.683c.8 0 1.199 0 1.678-.24.16-.161.32-.321.32-.562Zm-1.998-3.125v1.522c.32 0 .88 0 1.119-.08.799-.24.639-1.041.16-1.282-.48-.24-.959-.16-1.279-.16Z",
    fill: "url(#p)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.053 42.577c-3.915-2.484-5.512-3.366-8.948-3.366-3.275 0-6.071 1.443-7.43 2.084 0-.16.08-.801.16-.962.08-.4.16-.72.32-1.122.719-.24 1.278-.56 1.917-.881.879-.48 1.678-.801 2.477-.962l3.195-.32c3.116.24 5.673 1.923 8.31 3.285 0 .641.079 1.603 0 2.244Z",
    fill: "url(#q)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.196 39.292c1.119-.481 4.154-2.324 7.91-2.324 3.594 0 5.192.961 9.346 3.606",
    stroke: "url(#r)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 25.217,
    y1: 48.927,
    x2: 41.708,
    y2: 48.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFD44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 33.11,
    y1: 49.003,
    x2: 36.914,
    y2: 52.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7904",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 36.127,
    y1: 53.03,
    x2: 30.953,
    y2: 46.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 25.217,
    y1: 46.279,
    x2: 41.709,
    y2: 46.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7904",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 13,
    y1: 28.601,
    x2: 71,
    y2: 28.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6721FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 30.945,
    y1: 20.667,
    x2: 30.945,
    y2: 34.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 22.561,
    y1: 32.471,
    x2: 22.561,
    y2: 39.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 44.174,
    y1: 14.357,
    x2: 44.174,
    y2: 24.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 41.382,
    y1: 31.518,
    x2: 41.382,
    y2: 43.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 58.494,
    y1: 25.975,
    x2: 58.494,
    y2: 34.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 33.252,
    y1: 16.052,
    x2: 33.252,
    y2: 24.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 41.974,
    y1: 9.641,
    x2: 41.974,
    y2: 48.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 45.619,
    y1: 43.679,
    x2: 62.104,
    y2: 43.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFD44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 53.508,
    y1: 42.102,
    x2: 57.312,
    y2: 45.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7904",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 56.525,
    y1: 46.128,
    x2: 51.352,
    y2: 39.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 45.664,
    y1: 39.837,
    x2: 62.074,
    y2: 39.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7904",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 51,
    y1: 33.5,
    x2: 53.824,
    y2: 40.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.573,
    y: 0.52,
    width: 82.637,
    height: 66.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.305882 0 0 0 0 0.329412 0 0 0 0 0.494118 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_423",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5636fc1f7fe278191d1e399722d55019.svg";
export { ForwardRef as ReactComponent };